"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoInvite = void 0;
var AutoInvite = /** @class */ (function () {
    function AutoInvite(invite) {
        this.invite = invite;
    }
    AutoInvite.prototype.getImageUrl = function () {
        return '';
    };
    AutoInvite.prototype.getName = function (anon) {
        return this.invite.email;
    };
    AutoInvite.prototype.getId = function () {
        return this.invite.inviteId;
    };
    AutoInvite.prototype.isAnonymous = function () {
        return false;
    };
    AutoInvite.prototype.isJoined = function () {
        return false;
    };
    AutoInvite.prototype.isAdmin = function () {
        return false;
    };
    AutoInvite.prototype.isSiteAdmin = function () {
        return false;
    };
    AutoInvite.prototype.getJoinDate = function () {
        return new Date(this.invite.createdDate);
    };
    return AutoInvite;
}());
exports.AutoInvite = AutoInvite;
//# sourceMappingURL=AutoInvite.js.map